import store from '../../init/store.js'
import {getOrderedActionsFromSubmissions} from './get-order'
import {setBattleValue} from '../../redux-actions/battle-actions.js'
import {removeQueueSlot, extractQueuedSubmissions} from '../cloud-queue.js'
import {encodeCloudQueueActionString} from '../cloud-queue-encode-decode.js'
import {addEntryBeforeEntry} from '../../helpers/add-entry-before-entry.js'
import {getDeadTeams} from './get-dead-teams.js'
import {getUpdatedQueueWithDeadline} from './get-updated-queue-with-deadline'
import {isCloudActionRelevant} from './is-cloud-action-relevant'
import {trackHpOfTeams} from '../analysis/track-hp-of-teams.js'
import {getCombatantIdFromSelectingString} from '../get-combatant-id-from-selecting-string.js'

//Do this at the beginning of every series of turn/
//1 series is over when everybody gets a chance to go.

//Only master does this.
export function getNewTurnSeries() {

  // console.log('masters start turn series');

  //-------------------------------------------------------------
  //TODO: remove this section. It's just for dev testing
  //Let's just stub the cloudQueue here. Need the dynamic ids and stuff
  // const playerCasterId = Object.keys( store.getState().battle.combatants ).filter( key => {
  //     return key.match(/client_/)
  // })[0];
  //
  // const stubbedCloudQueue = [
  //   {
  //     turnSpot: true,//
  //     actions: []
  //   },
  //   {
  //     turnSpot: true,
  //     actions: [
  //       {
  //         //sortBeforeCombatant: "main",
  //         actionId: "natural_recover-deadline",
  //         casterId: "main",
  //         target: ["main"]
  //       }
  //       // {
  //       //   actionId: "special_promise-resolve",
  //       //   casterId: "doug",
  //       //   target: ["skeeter"]
  //       // }
  //     ]
  //   },
  // ];
  // setBattleValue({
  //   cloudQueue: stubbedCloudQueue
  // });

  //-------------------------------------------------------------


  //Get the latest cloudQueue
  //Get stuff from the cloudQueue for THIS turn!
  const currentCloudQueue = store.getState().battle.cloudQueue;
  const cloudQueueFirstEntry = extractQueuedSubmissions(currentCloudQueue);

  //Separate the cloud actions that need sorting
  const automaticCloudQueueActions = (cloudQueueFirstEntry.actions || []).filter(a => !a.sortBeforeCombatant) || [];
  const cloudQueueActionsToSort = (cloudQueueFirstEntry.actions || []).filter(a => a.sortBeforeCombatant) || [];

  //Order the combatants with including automatics up front
  let turnOrderedCombatantIds = [
    ...automaticCloudQueueActions.map(action => encodeCloudQueueActionString(action)),   //Use this string as a combatantId. Master will see it and know to submit and action for the cloudQueue.
    ...getOrderedActionsFromSubmissions(store.getState().battle.combatants)
  ];

  //Add in the ones that need to be sorted (lag recovery, etc)
  cloudQueueActionsToSort.forEach(action => {
    const sortBeforeCombatant = action.sortBeforeCombatant;
    turnOrderedCombatantIds = addEntryBeforeEntry(turnOrderedCombatantIds, sortBeforeCombatant, encodeCloudQueueActionString(action))
  });

  //Push cloud queue 1 turn forward
  const updatedCloudQueue = removeQueueSlot(currentCloudQueue);
  setBattleValue({
    cloudQueue: updatedCloudQueue
  });


  //SORT OF SIDE EFFECT
  //Build tracking object:
  trackHpOfTeams(); //Only for tracking. Doesn't affect battle
  //////////////////////////


  //Send this payload as `battleState`
  const nextCombatantId = getNextSelectingCombatant(turnOrderedCombatantIds, 0);
  return {
    combatantSelectingAction: nextCombatantId, //Set the first in the list as first to choose action
    arenaSubmissionMenuCombatantIdLock: nextCombatantId.match(/cloudQueueAction::/) ? null : nextCombatantId, //Only allow true combatantIds in this value
    seriesTurnOrder: turnOrderedCombatantIds,
    seriesTurnsSubmitters: [], //new empty array

    //Supply the latest cloudQueue so a new matster can potentially take over if needbe.
    cloudQueue: useCloudQueue(updatedCloudQueue) //get "firebase" safe version
  }
}

/** Firebase safe version of cloud queue / empty array for offline play */
function useCloudQueue(candidateCloudQueue) {
  if (store.getState().battle.isMultiplayerMode) {
    return candidateCloudQueue.length ? candidateCloudQueue : false; //give Firebase a value that won't be eaten
  }
  return candidateCloudQueue.length ? candidateCloudQueue : []; //empty array is fine for offline (no Firebase)
}


//Only master does this. Then sends out to everybody
//ONLINE & OFFLINE - get updated values of certain keys in battle state (not everything)
//EX: Next selecting combatant, or a new turn series with updated cloudQueue.
export function getUpdatedBattleState() { //TODO: This name is weird. Sometimes it gives the next combatant, but at the end of a turn it gives a whole new `getNewTurnSeries` too.

  //Check if battle is over
  const deadTeams = getDeadTeams();
  if (deadTeams.length) {
    //Need to do rollout of end notification?
    return {
      combatantSelectingAction: "battle-over"
    }
  }

  //Set the next person to the hotseat.
  let queue = store.getState().battle.seriesTurnOrder;

  //Potentially update the queue to include deadline status
  //to add an extra -deadline turn for current person.
  queue = getUpdatedQueueWithDeadline(
    queue,
    store.getState().battle.combatantSelectingAction,
    store.getState().battle.combatants
  );

  //Known deadlines are already set by "start turn series". This add is only for deadlines that are created mid-turn
  const indexOfCurrentSelectingCombatant = queue.indexOf(store.getState().battle.combatantSelectingAction);



  if (indexOfCurrentSelectingCombatant < queue.length - 1) {

    //Find the next valid person in the queue //Therefore, dead person will never get the "SelectionMenu" UI.
    const nextCombatantId = getNextSelectingCombatant(queue, indexOfCurrentSelectingCombatant + 1);



    if (!nextCombatantId) {
      //Last person in the queue was invalid, so start a new series
      //console.warn('last person was invalid. Start a new series')

      return getNewTurnSeries();
    }

    return {
      seriesTurnOrder: queue, //include latest seriesTurnOrder with every update (for Deadline adds)
      combatantSelectingAction: nextCombatantId,
      arenaSubmissionMenuCombatantIdLock: nextCombatantId.match(/cloudQueueAction::/) ? null : nextCombatantId //Do not allow cloudQueue IDs to be in this value
    };

  } else {
    //End of series. //Last person submitted their thing, so start a new series
    return getNewTurnSeries();
  }
}


function getNextSelectingCombatant(queue, index) {



  //Validate person at this index is ALIVE. If this person is invalid, try again with the next index.
  const casterId = getCombatantIdFromSelectingString(queue[index]);

  //Validate if this person is alive
  const combatantModel = store.getState().battle.combatants[casterId];

  //Check that a cloudQueue move is actually relevant (Recovering from lag, etc)
  const moveIsRelevant = isCloudActionRelevant(queue[index]);


  //Patch: Make sure Resolving Promises are okay valid, even if caster is dead.
  //Do not allow them to be eaten because not Relevant or caster being dead.
  let promiseResolveForce = false;
  if (queue[index].match(/special_promise-resolve/)) {
    promiseResolveForce = true;
  }
  //TODO: It bums me out that we can't read an Action property here, but we don't have the model.
  //TODO: In the future, if you need more "bypassers", just add their ids to the regex max test


  if ( (combatantModel.isAlive() && moveIsRelevant) || promiseResolveForce ) {
    return queue[index]; //return the string that is being validated, even if its cloudQueue (for indexOf)
  } else {
    //console.log('skipping', casterId);
  }

  //Try again with recursion
  if (queue[index + 1]) { //if something exists at next point
    return getNextSelectingCombatant(queue, index + 1); //try to validate the next person
  } else {
    //console.warn('last person was invalid. ruh roh');
    return null; //return falsy value as a signal that this queue is over.
  }


}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/start-turn-series.js